import type { Editor } from 'hugerte';

/**
 * Writes the image's natural pixel size onto its `width`/`height` attributes, so that the
 * `change-media` encode transformer stores them as `data-width`/`data-height` (mobile editors
 * rely on them to size an image before its bitmap loads).
 * Always overwrites: the upload swaps the local blob for the (compressed) uploaded file,
 * and the stored size must be the one of the file that ends up being served.
 * Returns whether the attributes were written.
 */
export const stampImageDimensions = (editor: Editor, image: HTMLImageElement): boolean => {
	const { naturalWidth, naturalHeight } = image;
	// not loaded yet, broken, or an SVG without intrinsic size
	if (!naturalWidth || !naturalHeight) return false;
	if (image.getAttribute('width') === String(naturalWidth) && image.getAttribute('height') === String(naturalHeight)) {
		return false;
	}
	// keeps the stamping out of the undo stack and the editor's dirty state
	editor.undoManager.ignore(() => {
		editor.dom.setAttribs(image, { width: naturalWidth, height: naturalHeight });
	});
	return true;
};
